// 国家和币种
// COUNTRY_CURRENCY 结构：identity + tax + shipping{ host_by_weight, trackit_*, metro_* }
// 配件：默认 QUOTATION_COUNTRY_RATE_DEFAULTS；常用方案 QUOTATION_ACCESSORY_PRESETS
// 国家仅 accessories_preset 和/或 accessories 差异字段（Excel 配件 sheet + 脚本写回）
const COUNTRY_CURRENCY = [
  {
    "country_name": "加拿大",
    "country_name_en": "Canada",
    "country_code": "CA",
    "currency_code": "CAD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 180,
      "trackit": 220,
      "metro_hub": 970,
      "metrohub_09yu": 511,
      "metrohub_09tr": 749
    },
    "tax": "10.00"
  },
  {
    "country_name": "法国",
    "country_name_en": "France",
    "country_code": "FR",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "20.00"
  },
  {
    "country_name": "德国",
    "country_name_en": "Germany",
    "country_code": "DE",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "19.00"
  },
  {
    "country_name": "英国",
    "country_name_en": "United Kingdom",
    "country_code": "GB",
    "currency_code": "GBP",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "20.00",
    "accessories": {
      "by_weight": {
        "w10": 5
      }
    }
  },
  {
    "country_name": "阿森松岛",
    "country_name_en": "Ascension Island",
    "country_code": "AC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "安道尔",
    "country_name_en": "Andorra",
    "country_code": "AD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 120,
      "trackit": 300,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "阿拉伯联合酋长国",
    "country_name_en": "United Arab Emirates",
    "country_code": "AE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 180,
      "trackit": 330,
      "metro_hub": 1113,
      "metrohub_09yu": 464,
      "metrohub_09tr": 796
    },
    "accessories_preset": "remote_tier_a",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "阿富汗",
    "country_name_en": "Afghanistan",
    "country_code": "AF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "安提瓜和巴布达",
    "country_name_en": "Antigua and Barbuda",
    "country_code": "AG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "安圭拉",
    "country_name_en": "Anguilla",
    "country_code": "AI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "阿尔巴尼亚",
    "country_name_en": "Albania",
    "country_code": "AL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "亚美尼亚",
    "country_name_en": "Armenia",
    "country_code": "AM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "安哥拉",
    "country_name_en": "Angola",
    "country_code": "AO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 987
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "阿根廷",
    "country_name_en": "Argentina",
    "country_code": "AR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_b"
  },
  {
    "country_name": "澳大利亚",
    "country_name_en": "Australia",
    "country_code": "AU",
    "currency_code": "AUD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 100,
      "trackit": 150,
      "metro_hub": 692,
      "metrohub_09yu": 334,
      "metrohub_09tr": 491
    },
    "tax": "10.00"
  },
  {
    "country_name": "阿鲁巴",
    "country_name_en": "Aruba",
    "country_code": "AW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "奥兰群岛",
    "country_name_en": "Åland Islands",
    "country_code": "AX",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "阿塞拜疆",
    "country_name_en": "Azerbaijan",
    "country_code": "AZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "波斯尼亚和黑塞哥维那",
    "country_name_en": "Bosnia and Herzegovina",
    "country_code": "BA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "巴巴多斯",
    "country_name_en": "Barbados",
    "country_code": "BB",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "孟加拉国",
    "country_name_en": "Bangladesh",
    "country_code": "BD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 529,
      "metrohub_09tr": 784
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "布基纳法索",
    "country_name_en": "Burkina Faso",
    "country_code": "BF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "巴林",
    "country_name_en": "Bahrain",
    "country_code": "BH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 120,
      "trackit": 330,
      "metro_hub": 1113,
      "metrohub_09yu": 464,
      "metrohub_09tr": 796
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "布隆迪",
    "country_name_en": "Burundi",
    "country_code": "BI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "贝宁",
    "country_name_en": "Benin",
    "country_code": "BJ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣巴泰勒米",
    "country_name_en": "Saint Barthélemy",
    "country_code": "BL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "百慕大",
    "country_name_en": "Bermuda",
    "country_code": "BM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "文莱",
    "country_name_en": "Brunei",
    "country_code": "BN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 390,
      "metro_hub": 1173,
      "metrohub_09yu": 258,
      "metrohub_09tr": 443
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "玻利维亚",
    "country_name_en": "Bolivia",
    "country_code": "BO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "荷属加勒比区",
    "country_name_en": "Caribbean Netherlands",
    "country_code": "BQ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "巴西",
    "country_name_en": "Brazil",
    "country_code": "BR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_b",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "巴哈马",
    "country_name_en": "Bahamas",
    "country_code": "BS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "不丹",
    "country_name_en": "Bhutan",
    "country_code": "BT",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 529,
      "metrohub_09tr": 784
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "博茨瓦纳",
    "country_name_en": "Botswana",
    "country_code": "BW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "白俄罗斯",
    "country_name_en": "Belarus",
    "country_code": "BY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1162,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "伯利兹",
    "country_name_en": "Belize",
    "country_code": "BZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "科科斯（基林）群岛",
    "country_name_en": "Cocos (Keeling) Islands",
    "country_code": "CC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "刚果（金）",
    "country_name_en": "Democratic Republic of the Congo",
    "country_code": "CD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "中非共和国",
    "country_name_en": "Central African Republic",
    "country_code": "CF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "刚果（布）",
    "country_name_en": "Republic of the Congo",
    "country_code": "CG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "瑞士",
    "country_name_en": "Switzerland",
    "country_code": "CH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 300,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "7.70",
    "accessories_preset": "sea_middle_tier_w150_200"
  },
  {
    "country_name": "科特迪瓦",
    "country_name_en": "Côte d'Ivoire",
    "country_code": "CI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "库克群岛",
    "country_name_en": "Cook Islands",
    "country_code": "CK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "智利",
    "country_name_en": "Chile",
    "country_code": "CL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_b",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "喀麦隆",
    "country_name_en": "Cameroon",
    "country_code": "CM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "中国",
    "country_name_en": "China",
    "country_code": "CN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 0,
      "trackit": "/",
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "accessories_zero"
  },
  {
    "country_name": "哥伦比亚",
    "country_name_en": "Colombia",
    "country_code": "CO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_b"
  },
  {
    "country_name": "哥斯达黎加",
    "country_name_en": "Costa Rica",
    "country_code": "CR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "佛得角",
    "country_name_en": "Cape Verde",
    "country_code": "CV",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "库拉索",
    "country_name_en": "Curaçao",
    "country_code": "CW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣诞岛",
    "country_name_en": "Christmas Island",
    "country_code": "CX",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "吉布提",
    "country_name_en": "Djibouti",
    "country_code": "DJ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "多米尼克",
    "country_name_en": "Dominica",
    "country_code": "DM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "多米尼加共和国",
    "country_name_en": "Dominican Republic",
    "country_code": "DO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "阿尔及利亚",
    "country_name_en": "Algeria",
    "country_code": "DZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "厄瓜多尔",
    "country_name_en": "Ecuador",
    "country_code": "EC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "埃及",
    "country_name_en": "Egypt",
    "country_code": "EG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 464,
      "metrohub_09tr": 796
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "西撒哈拉",
    "country_name_en": "Western Sahara",
    "country_code": "EH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "厄立特里亚",
    "country_name_en": "Eritrea",
    "country_code": "ER",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "埃塞俄比亚",
    "country_name_en": "Ethiopia",
    "country_code": "ET",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "斐济",
    "country_name_en": "Fiji",
    "country_code": "FJ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "福克兰群岛",
    "country_name_en": "Falkland Islands",
    "country_code": "FK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "法罗群岛",
    "country_name_en": "Faroe Islands",
    "country_code": "FO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "加蓬",
    "country_name_en": "Gabon",
    "country_code": "GA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "格林纳达",
    "country_name_en": "Grenada",
    "country_code": "GD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "格鲁吉亚",
    "country_name_en": "Georgia",
    "country_code": "GE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "法属圭亚那",
    "country_name_en": "French Guiana",
    "country_code": "GF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "根西岛",
    "country_name_en": "Guernsey",
    "country_code": "GG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "加纳",
    "country_name_en": "Ghana",
    "country_code": "GH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "直布罗陀",
    "country_name_en": "Gibraltar",
    "country_code": "GI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "格陵兰",
    "country_name_en": "Greenland",
    "country_code": "GL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "冈比亚",
    "country_name_en": "Gambia",
    "country_code": "GM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "几内亚",
    "country_name_en": "Guinea",
    "country_code": "GN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "瓜德罗普",
    "country_name_en": "Guadeloupe",
    "country_code": "GP",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "赤道几内亚",
    "country_name_en": "Equatorial Guinea",
    "country_code": "GQ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "南乔治亚和南桑威奇群岛",
    "country_name_en": "South Georgia and the South Sandwich Islands",
    "country_code": "GS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "危地马拉",
    "country_name_en": "Guatemala",
    "country_code": "GT",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "几内亚比绍",
    "country_name_en": "Guinea-Bissau",
    "country_code": "GW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圭亚那",
    "country_name_en": "Guyana",
    "country_code": "GY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "香港特别行政区",
    "country_name_en": "Hong Kong",
    "country_code": "HK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 10,
        "shipping_md": 10,
        "shipping_lg": 10
      },
      "trackit_sr": 50,
      "trackit": 80,
      "metro_hub": 247,
      "metrohub_09yu": 72,
      "metrohub_09tr": 106
    },
    "accessories_preset": "local_tier_hk"
  },
  {
    "country_name": "洪都拉斯",
    "country_name_en": "Honduras",
    "country_code": "HN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "海地",
    "country_name_en": "Haiti",
    "country_code": "HT",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "印度尼西亚",
    "country_name_en": "Indonesia",
    "country_code": "ID",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 25,
        "shipping_md": 35,
        "shipping_lg": 50
      },
      "trackit_sr": 80,
      "trackit": 200,
      "metro_hub": 481,
      "metrohub_09yu": 189,
      "metrohub_09tr": 279
    },
    "accessories_preset": "sea_middle_tier_w150_200_no_power"
  },
  {
    "country_name": "以色列",
    "country_name_en": "Israel",
    "country_code": "IL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 50,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 430,
      "metro_hub": 1104,
      "metrohub_09yu": 464,
      "metrohub_09tr": 796
    },
    "accessories_preset": "sea_middle_tier",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "马恩岛",
    "country_name_en": "Isle of Man",
    "country_code": "IM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 587,
      "metrohub_09tr": 987
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "印度",
    "country_name_en": "India",
    "country_code": "IN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 120,
      "trackit": 300,
      "metro_hub": 581,
      "metrohub_09yu": 187,
      "metrohub_09tr": 275
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "英属印度洋领地",
    "country_name_en": "British Indian Ocean Territory",
    "country_code": "IO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "伊拉克",
    "country_name_en": "Iraq",
    "country_code": "IQ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "冰岛",
    "country_name_en": "Iceland",
    "country_code": "IS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 50,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "泽西岛",
    "country_name_en": "Jersey",
    "country_code": "JE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "牙买加",
    "country_name_en": "Jamaica",
    "country_code": "JM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "约旦",
    "country_name_en": "Jordan",
    "country_code": "JO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "肯尼亚",
    "country_name_en": "Kenya",
    "country_code": "KE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "吉尔吉斯斯坦",
    "country_name_en": "Kyrgyzstan",
    "country_code": "KG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "柬埔寨",
    "country_name_en": "Cambodia",
    "country_code": "KH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1089,
      "metrohub_09yu": 258,
      "metrohub_09tr": 443
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "基里巴斯",
    "country_name_en": "Kiribati",
    "country_code": "KI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "科摩罗",
    "country_name_en": "Comoros",
    "country_code": "KM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣基茨和尼维斯",
    "country_name_en": "Saint Kitts and Nevis",
    "country_code": "KN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "韩国",
    "country_name_en": "South Korea",
    "country_code": "KR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 20,
        "shipping_md": 25,
        "shipping_lg": 30
      },
      "trackit_sr": 50,
      "trackit": 80,
      "metro_hub": 255,
      "metrohub_09yu": 87,
      "metrohub_09tr": 126
    },
    "tax": "10.00",
    "accessories_preset": "sea_middle_tier_w10_10",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "科威特",
    "country_name_en": "Kuwait",
    "country_code": "KW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 464,
      "metrohub_09tr": 796
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "开曼群岛",
    "country_name_en": "Cayman Islands",
    "country_code": "KY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "哈萨克斯坦",
    "country_name_en": "Kazakhstan",
    "country_code": "KZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 120,
      "trackit": 330,
      "metro_hub": 1113,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "老挝",
    "country_name_en": "Laos",
    "country_code": "LA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 258,
      "metrohub_09tr": 443
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "黎巴嫩",
    "country_name_en": "Lebanon",
    "country_code": "LB",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "圣卢西亚",
    "country_name_en": "Saint Lucia",
    "country_code": "LC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "列支敦士登",
    "country_name_en": "Liechtenstein",
    "country_code": "LI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "斯里兰卡",
    "country_name_en": "Sri Lanka",
    "country_code": "LK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 529,
      "metrohub_09tr": 784
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "利比里亚",
    "country_name_en": "Liberia",
    "country_code": "LR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "莱索托",
    "country_name_en": "Lesotho",
    "country_code": "LS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "利比亚",
    "country_name_en": "Libya",
    "country_code": "LY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "摩洛哥",
    "country_name_en": "Morocco",
    "country_code": "MA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "摩纳哥",
    "country_name_en": "Monaco",
    "country_code": "MC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "摩尔多瓦",
    "country_name_en": "Moldova",
    "country_code": "MD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "黑山",
    "country_name_en": "Montenegro",
    "country_code": "ME",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "法属圣马丁",
    "country_name_en": "Saint Martin",
    "country_code": "MF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "马达加斯加",
    "country_name_en": "Madagascar",
    "country_code": "MG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "北马其顿",
    "country_name_en": "North Macedonia",
    "country_code": "MK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 587,
      "metrohub_09tr": 987
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "马里",
    "country_name_en": "Mali",
    "country_code": "ML",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "缅甸",
    "country_name_en": "Myanmar",
    "country_code": "MM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 529,
      "metrohub_09tr": 784
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "蒙古",
    "country_name_en": "Mongolia",
    "country_code": "MN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "澳门特别行政区",
    "country_name_en": "Macao",
    "country_code": "MO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 10,
        "shipping_md": 10,
        "shipping_lg": 10
      },
      "trackit_sr": 50,
      "trackit": 80,
      "metro_hub": 247,
      "metrohub_09yu": 161,
      "metrohub_09tr": 271
    },
    "accessories_preset": "local_tier_hk"
  },
  {
    "country_name": "马提尼克",
    "country_name_en": "Martinique",
    "country_code": "MQ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "毛里塔尼亚",
    "country_name_en": "Mauritania",
    "country_code": "MR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "蒙特塞拉特",
    "country_name_en": "Montserrat",
    "country_code": "MS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "毛里求斯",
    "country_name_en": "Mauritius",
    "country_code": "MU",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "马尔代夫",
    "country_name_en": "Maldives",
    "country_code": "MV",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1190
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "马拉维",
    "country_name_en": "Malawi",
    "country_code": "MW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "墨西哥",
    "country_name_en": "Mexico",
    "country_code": "MX",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 25,
        "shipping_md": 35,
        "shipping_lg": 50
      },
      "trackit_sr": 200,
      "trackit": 365,
      "metro_hub": 970,
      "metrohub_09yu": 511,
      "metrohub_09tr": 749
    },
    "tax": "16.00",
    "accessories_preset": "sea_middle_tier_w150_300"
  },
  {
    "country_name": "马来西亚",
    "country_name_en": "Malaysia",
    "country_code": "MY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 20,
        "shipping_md": 25,
        "shipping_lg": 30
      },
      "trackit_sr": 50,
      "trackit": 100,
      "metro_hub": 268,
      "metrohub_09yu": 74,
      "metrohub_09tr": 109
    },
    "accessories_preset": "sea_middle_tier_w150_120"
  },
  {
    "country_name": "莫桑比克",
    "country_name_en": "Mozambique",
    "country_code": "MZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "纳米比亚",
    "country_name_en": "Namibia",
    "country_code": "NA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "新喀里多尼亚",
    "country_name_en": "New Caledonia",
    "country_code": "NC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "尼日尔",
    "country_name_en": "Niger",
    "country_code": "NE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "诺福克岛",
    "country_name_en": "Norfolk Island",
    "country_code": "NF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "尼日利亚",
    "country_name_en": "Nigeria",
    "country_code": "NG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "尼加拉瓜",
    "country_name_en": "Nicaragua",
    "country_code": "NI",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "尼泊尔",
    "country_name_en": "Nepal",
    "country_code": "NP",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "瑙鲁",
    "country_name_en": "Nauru",
    "country_code": "NR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "纽埃",
    "country_name_en": "Niue",
    "country_code": "NU",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "新西兰",
    "country_name_en": "New Zealand",
    "country_code": "NZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 50,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 280,
      "metro_hub": 792,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "19.00",
    "accessories_preset": "sea_middle_tier_w150_200"
  },
  {
    "country_name": "阿曼",
    "country_name_en": "Oman",
    "country_code": "OM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "巴拿马",
    "country_name_en": "Panama",
    "country_code": "PA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "秘鲁",
    "country_name_en": "Peru",
    "country_code": "PE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "法属波利尼西亚",
    "country_name_en": "French Polynesia",
    "country_code": "PF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "巴布亚新几内亚",
    "country_name_en": "Papua New Guinea",
    "country_code": "PG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "菲律宾",
    "country_name_en": "Philippines",
    "country_code": "PH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 20,
        "shipping_md": 25,
        "shipping_lg": 30
      },
      "trackit_sr": 50,
      "trackit": 130,
      "metro_hub": 324,
      "metrohub_09yu": 106,
      "metrohub_09tr": 154
    },
    "accessories_preset": "sea_middle_tier_w150_120"
  },
  {
    "country_name": "巴基斯坦",
    "country_name_en": "Pakistan",
    "country_code": "PK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 535,
      "metrohub_09tr": 784
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣皮埃尔和密克隆群岛",
    "country_name_en": "Saint Pierre and Miquelon",
    "country_code": "PM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "皮特凯恩群岛",
    "country_name_en": "Pitcairn Islands",
    "country_code": "PN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "巴勒斯坦领土",
    "country_name_en": "Palestinian Territories",
    "country_code": "PS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 0,
      "trackit": "/",
      "metro_hub": 1283,
      "metrohub_09yu": 587,
      "metrohub_09tr": 987
    }
  },
  {
    "country_name": "巴拉圭",
    "country_name_en": "Paraguay",
    "country_code": "PY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "卡塔尔",
    "country_name_en": "Qatar",
    "country_code": "QA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 180,
      "trackit": 330,
      "metro_hub": 1113,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier_w150_200_no_power"
  },
  {
    "country_name": "留尼汪",
    "country_name_en": "Réunion",
    "country_code": "RE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "塞尔维亚",
    "country_name_en": "Serbia",
    "country_code": "RS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1324,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "俄罗斯",
    "country_name_en": "Russia",
    "country_code": "RU",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 30,
        "shipping_md": 45,
        "shipping_lg": 60
      },
      "trackit_sr": 120,
      "trackit": 330,
      "metro_hub": 842,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier_w150_200"
  },
  {
    "country_name": "卢旺达",
    "country_name_en": "Rwanda",
    "country_code": "RW",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "沙特阿拉伯",
    "country_name_en": "Saudi Arabia",
    "country_code": "SA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 180,
      "trackit": 330,
      "metro_hub": 1113,
      "metrohub_09yu": 464,
      "metrohub_09tr": 796
    },
    "accessories_preset": "sea_middle_tier_w150_200_no_power"
  },
  {
    "country_name": "所罗门群岛",
    "country_name_en": "Solomon Islands",
    "country_code": "SB",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "塞舌尔",
    "country_name_en": "Seychelles",
    "country_code": "SC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "苏丹",
    "country_name_en": "Sudan",
    "country_code": "SD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "新加坡",
    "country_name_en": "Singapore",
    "country_code": "SG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 20,
        "shipping_md": 25,
        "shipping_lg": 30
      },
      "trackit_sr": 50,
      "trackit": 110,
      "metro_hub": 282,
      "metrohub_09yu": 83,
      "metrohub_09tr": 120
    },
    "tax": "9.00",
    "accessories_preset": "sea_middle_tier_w150_120"
  },
  {
    "country_name": "圣赫勒拿",
    "country_name_en": "Saint Helena",
    "country_code": "SH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "斯瓦尔巴和扬马延",
    "country_name_en": "Svalbard and Jan Mayen",
    "country_code": "SJ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1527,
      "metrohub_09yu": 587,
      "metrohub_09tr": 987
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "塞拉利昂",
    "country_name_en": "Sierra Leone",
    "country_code": "SL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣马力诺",
    "country_name_en": "San Marino",
    "country_code": "SM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 120,
      "trackit": 300,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "塞内加尔",
    "country_name_en": "Senegal",
    "country_code": "SN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "索马里",
    "country_name_en": "Somalia",
    "country_code": "SO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "苏里南",
    "country_name_en": "Suriname",
    "country_code": "SR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "南苏丹",
    "country_name_en": "South Sudan",
    "country_code": "SS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣多美和普林西比",
    "country_name_en": "São Tomé and Príncipe",
    "country_code": "ST",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "萨尔瓦多",
    "country_name_en": "El Salvador",
    "country_code": "SV",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "荷属圣马丁",
    "country_name_en": "Sint Maarten",
    "country_code": "SX",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "斯威士兰",
    "country_name_en": "Eswatini",
    "country_code": "SZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "特里斯坦-达库尼亚群岛",
    "country_name_en": "Tristan da Cunha",
    "country_code": "TA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "特克斯和凯科斯群岛",
    "country_name_en": "Turks and Caicos Islands",
    "country_code": "TC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "乍得",
    "country_name_en": "Chad",
    "country_code": "TD",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "法属南部领地",
    "country_name_en": "French Southern Territories",
    "country_code": "TF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "多哥",
    "country_name_en": "Togo",
    "country_code": "TG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "泰国",
    "country_name_en": "Thailand",
    "country_code": "TH",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 20,
        "shipping_md": 25,
        "shipping_lg": 30
      },
      "trackit_sr": 50,
      "trackit": 130,
      "metro_hub": 341,
      "metrohub_09yu": 118,
      "metrohub_09tr": 173
    },
    "accessories_preset": "sea_middle_tier_w150_120"
  },
  {
    "country_name": "塔吉克斯坦",
    "country_name_en": "Tajikistan",
    "country_code": "TJ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 587,
      "metrohub_09tr": 987
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "托克劳",
    "country_name_en": "Tokelau",
    "country_code": "TK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "东帝汶",
    "country_name_en": "Timor-Leste",
    "country_code": "TL",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1190
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "土库曼斯坦",
    "country_name_en": "Turkmenistan",
    "country_code": "TM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "突尼斯",
    "country_name_en": "Tunisia",
    "country_code": "TN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "汤加",
    "country_name_en": "Tonga",
    "country_code": "TO",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "土耳其",
    "country_name_en": "Turkey",
    "country_code": "TR",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 390,
      "metro_hub": 1173,
      "metrohub_09yu": 464,
      "metrohub_09tr": 784
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "特立尼达和多巴哥",
    "country_name_en": "Trinidad and Tobago",
    "country_code": "TT",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "图瓦卢",
    "country_name_en": "Tuvalu",
    "country_code": "TV",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "坦桑尼亚",
    "country_name_en": "Tanzania",
    "country_code": "TZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "乌克兰",
    "country_name_en": "Ukraine",
    "country_code": "UA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 0,
      "trackit": "/",
      "metro_hub": 1174,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    }
  },
  {
    "country_name": "乌干达",
    "country_name_en": "Uganda",
    "country_code": "UG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "美国本土外小岛屿",
    "country_name_en": "U.S. Outlying Islands",
    "country_code": "UM",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 50,
        "shipping_lg": 60
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "乌拉圭",
    "country_name_en": "Uruguay",
    "country_code": "UY",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "乌兹别克斯坦",
    "country_name_en": "Uzbekistan",
    "country_code": "UZ",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "梵蒂冈",
    "country_name_en": "Vatican City",
    "country_code": "VA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "圣文森特和格林纳丁斯",
    "country_name_en": "Saint Vincent and the Grenadines",
    "country_code": "VC",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "委内瑞拉",
    "country_name_en": "Venezuela",
    "country_code": "VE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "英属维尔京群岛",
    "country_name_en": "British Virgin Islands",
    "country_code": "VG",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "越南",
    "country_name_en": "Vietnam",
    "country_code": "VN",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 20,
        "shipping_md": 25,
        "shipping_lg": 30
      },
      "trackit_sr": 50,
      "trackit": 150,
      "metro_hub": 383,
      "metrohub_09yu": 138,
      "metrohub_09tr": 200
    },
    "accessories_preset": "sea_middle_tier_w10_10"
  },
  {
    "country_name": "瓦努阿图",
    "country_name_en": "Vanuatu",
    "country_code": "VU",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "瓦利斯和富图纳",
    "country_name_en": "Wallis and Futuna",
    "country_code": "WF",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "萨摩亚",
    "country_name_en": "Samoa",
    "country_code": "WS",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 500,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "科索沃",
    "country_name_en": "Kosovo",
    "country_code": "XK",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 80,
        "shipping_md": 120,
        "shipping_lg": 150
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1677,
      "metrohub_09yu": 587,
      "metrohub_09tr": 987
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "也门",
    "country_name_en": "Yemen",
    "country_code": "YE",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1433,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "remote_tier_a"
  },
  {
    "country_name": "奥地利",
    "country_name_en": "Austria",
    "country_code": "AT",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "20.00"
  },
  {
    "country_name": "比利时",
    "country_name_en": "Belgium",
    "country_code": "BE",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "21.00"
  },
  {
    "country_name": "保加利亚",
    "country_name_en": "Bulgaria",
    "country_code": "BG",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 300,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "20.00"
  },
  {
    "country_name": "塞浦路斯",
    "country_name_en": "Cyprus",
    "country_code": "CY",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 150,
      "trackit": 250,
      "metro_hub": 862,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "19.00",
    "accessories_preset": "default_spray_power_zero"
  },
  {
    "country_name": "捷克",
    "country_name_en": "Czech Republic",
    "country_code": "CZ",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "21.00"
  },
  {
    "country_name": "丹麦",
    "country_name_en": "Denmark",
    "country_code": "DK",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "25.00"
  },
  {
    "country_name": "爱沙尼亚",
    "country_name_en": "Estonia",
    "country_code": "EE",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "20.00"
  },
  {
    "country_name": "西班牙",
    "country_name_en": "Spain",
    "country_code": "ES",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "21.00"
  },
  {
    "country_name": "芬兰",
    "country_name_en": "Finland",
    "country_code": "FI",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "25.50"
  },
  {
    "country_name": "希腊",
    "country_name_en": "Greece",
    "country_code": "GR",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "24.00"
  },
  {
    "country_name": "南非",
    "country_name_en": "South Africa",
    "country_code": "ZA",
    "currency_code": "USD",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 40,
        "shipping_md": 60,
        "shipping_lg": 80
      },
      "trackit_sr": 300,
      "trackit": 650,
      "metro_hub": 1274,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "accessories_preset": "sea_middle_tier"
  },
  {
    "country_name": "克罗地亚",
    "country_name_en": "Croatia",
    "country_code": "HR",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "25.00"
  },
  {
    "country_name": "匈牙利",
    "country_name_en": "Hungary",
    "country_code": "HU",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "27.00"
  },
  {
    "country_name": "爱尔兰",
    "country_name_en": "Ireland",
    "country_code": "IE",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "23.00"
  },
  {
    "country_name": "意大利",
    "country_name_en": "Italy",
    "country_code": "IT",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "22.00"
  },
  {
    "country_name": "立陶宛",
    "country_name_en": "Lithuania",
    "country_code": "LT",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "21.00"
  },
  {
    "country_name": "卢森堡",
    "country_name_en": "Luxembourg",
    "country_code": "LU",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 1150,
      "metrohub_09yu": 0,
      "metrohub_09tr": 0
    },
    "tax": "17.00"
  },
  {
    "country_name": "拉脱维亚",
    "country_name_en": "Latvia",
    "country_code": "LV",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "21.00"
  },
  {
    "country_name": "马耳他",
    "country_name_en": "Malta",
    "country_code": "MT",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "18.00",
    "accessories_preset": "default_spray_power_zero"
  },
  {
    "country_name": "荷兰",
    "country_name_en": "Netherlands",
    "country_code": "NL",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "21.00"
  },
  {
    "country_name": "挪威",
    "country_name_en": "Norway",
    "country_code": "NO",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 300,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "25.00"
  },
  {
    "country_name": "波兰",
    "country_name_en": "Poland",
    "country_code": "PL",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "23.00"
  },
  {
    "country_name": "葡萄牙",
    "country_name_en": "Portugal",
    "country_code": "PT",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "23.00"
  },
  {
    "country_name": "罗马尼亚",
    "country_name_en": "Romania",
    "country_code": "RO",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 250,
      "trackit": 220,
      "metro_hub": 974,
      "metrohub_09yu": 733,
      "metrohub_09tr": 1233
    },
    "tax": "19.00"
  },
  {
    "country_name": "瑞典",
    "country_name_en": "Sweden",
    "country_code": "SE",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 200,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "25.00"
  },
  {
    "country_name": "斯洛文尼亚",
    "country_name_en": "Slovenia",
    "country_code": "SI",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "22.00",
    "accessories_preset": "sea_middle_tier",
    "accessories": {
      "power": 9
    }
  },
  {
    "country_name": "斯洛伐克",
    "country_name_en": "Slovakia",
    "country_code": "SK",
    "currency_code": "EUR",
    "shipping": {
      "host_by_weight": {
        "shipping_sm": 0,
        "shipping_md": 0,
        "shipping_lg": 0
      },
      "trackit_sr": 120,
      "trackit": 220,
      "metro_hub": 812,
      "metrohub_09yu": 351,
      "metrohub_09tr": 517
    },
    "tax": "23.00"
  }
]


// 全球站所有市场
const markets = [
  {
    id: 'gid://shopify/Market/1669365995',
    name: 'Canada',
    handle: 'b154a6b2-878e-4c36-af7c-22aee132a577',
  },
  {
    id: 'gid://shopify/Market/15272607979',
    name: 'EUR',
    handle: 'eur',
  },
  {
    id: 'gid://shopify/Market/20965621995',
    name: 'France',
    handle: '法国',
  },
  {
    id: 'gid://shopify/Market/20965785835',
    name: 'Germany',
    handle: 'germany',
  },
  {
    id: 'gid://shopify/Market/1669398763',
    name: 'International',
    handle: 'international',
  },
  {
    id: 'gid://shopify/Market/15268282603',
    name: 'UK',
    handle: 'uk',
  },
];
// 币种
const CURRENCY_MAP = {
  USD: {
    currencyCode: 'EUR',
    currencyName: '美元',
    currencySymbol: '$'
  },
  EUR: {
    currencyCode: 'USD',
    currencyName: '欧元',
    currencySymbol: '€'
  },
  GBP: {
    currencyCode: 'GBP',
    currencyName: '英镑',
    currencySymbol: '£'
  },
};

// QUOTATION-FREIGHT-INLINE-BEGIN
/**
 * 报价单运费：国家费率解析 + SKU 规则（与 tmp/sync_country_currency_from_xlsx.py 同步）
 * 依赖全局：COUNTRY_CURRENCY、selectedCountryCode
 */
(function (global) {
  'use strict';

  /** 各站 liquid 可在加载本文件前设置 window.QUOTATION_SITE_OVERRIDES */
  var SITE_OVERRIDES = global.QUOTATION_SITE_OVERRIDES || {};
  var hostFreightEnabled = SITE_OVERRIDES.hostFreightEnabled !== false;
  var metroHubRequiresWeight = SITE_OVERRIDES.metroHubRequiresWeight === true;

  var QUOTATION_COUNTRY_RATE_DEFAULTS = {
    accessories: {
      aesub: 9,
      ab6abp: 6,
      power: 9,
      by_weight: {
        w02: 5,
        w05: 5,
        w10: 10,
        w20: 15,
        w100: 50,
        w150: 200,
      },
    },
  };

  var QUOTATION_ACCESSORY_PRESETS = {
    remote_tier_a: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 7, w05: 15, w10: 30, w20: 40, w100: 200, w150: 650 },
    },
    sea_middle_tier: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 5, w05: 9, w10: 15, w20: 20, w100: 100, w150: 650 },
    },
    sea_middle_tier_w150_120: {
      aesub: 0,
      ab6abp: 0,
      power: 9,
      by_weight: { w02: 5, w05: 9, w10: 15, w20: 20, w100: 100, w150: 120 },
    },
    sea_middle_tier_w150_200: {
      aesub: 0,
      ab6abp: 0,
      power: 9,
      by_weight: { w02: 5, w05: 9, w10: 15, w20: 20, w100: 100, w150: 200 },
    },
    accessories_zero: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 0, w05: 0, w10: 0, w20: 0, w100: 0, w150: 0 },
    },
    sea_middle_tier_w150_200_no_power: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 5, w05: 9, w10: 15, w20: 20, w100: 100, w150: 200 },
    },
    remote_tier_b: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 9, w05: 15, w10: 30, w20: 40, w100: 200, w150: 650 },
    },
    local_tier_hk: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 5, w05: 9, w10: 10, w20: 15, w100: 50, w150: 80 },
    },
    default_spray_power_zero: {
      aesub: 9,
      ab6abp: 6,
      power: 0,
      by_weight: { w02: 5, w05: 5, w10: 10, w20: 15, w100: 50, w150: 200 },
    },
    sea_middle_tier_w150_300: {
      aesub: 0,
      ab6abp: 0,
      power: 9,
      by_weight: { w02: 5, w05: 9, w10: 15, w20: 20, w100: 100, w150: 300 },
    },
    sea_middle_tier_w10_10: {
      aesub: 0,
      ab6abp: 0,
      power: 0,
      by_weight: { w02: 5, w05: 9, w10: 10, w20: 20, w100: 100, w150: 120 },
    },
  };

  /**
   * 与原先 liquid 常量同名，便于对照；逻辑以 QUOTATION_CONFIG_DEFAULT 为准。
   * 运费优先级（与 quotation-page-dev skill 一致）：
   * 1 specialFreightBySku → 2 TRACKIT-SR* → 3 METRO-HUB-09TR/YU → 4 Trackit 名单/BUNDLE+TRACKIT
   * → 5 METRO-HUB → 6 指定配件 SKU → 7 Accessories 集合重量档 → 8 主机重量档
   */
  var TRACKIT_SKU_NAMES = [
    'TRACKIT',
    'BUNDLE-TRACKIT-REVODESIGN-1YEAR',
    'TRACKIT-CARRY-CASE',
  ];
  var METROHUB_SKU_NAMES = ['METRO-HUB'];
  var ACCESS_SKU_NAMES = [
    'SCANNING-SPRAY',
    'SCANNING-SPRAY-AB6',
    'SCANNING-SPRAY-ABP',
    'SCANNING-SPRAY-AB6-ABP',
    'POWER-BANK',
  ];

  var QUOTATION_CONFIG_DEFAULT = {
    specialFreightBySku: {},
    trackitSkuNames: TRACKIT_SKU_NAMES,
    metroHubSkuNames: METROHUB_SKU_NAMES,
    metroHub09Skus: {
      'METRO-HUB-09TR': 'metrohub_09tr',
      'METRO-HUB-09YU': 'metrohub_09yu',
    },
    trackitSrSkuPattern: /TRACKIT-SR/i,
    accessSkuNames: ACCESS_SKU_NAMES,
    accessoryCollectionKeywords: ['Accessories', 'Accessoires', 'Zubehör'],
    hostWeightThresholds: { sm: 1500, md: 4500 },
    accessoryWeightThresholds: [
      { max: 200, key: 'w02' },
      { max: 500, key: 'w05' },
      { max: 1000, key: 'w10' },
      { max: 2000, key: 'w20' },
      { max: 10000, key: 'w100' },
      { max: Infinity, key: 'w150' },
    ],
  };

  function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function mergeAccessoryNested(base, patch) {
    if (!patch) return deepClone(base);
    var out = {
      aesub: patch.aesub != null ? patch.aesub : base.aesub,
      ab6abp: patch.ab6abp != null ? patch.ab6abp : base.ab6abp,
      power: patch.power != null ? patch.power : base.power,
      by_weight: Object.assign({}, base.by_weight, patch.by_weight || {}),
    };
    return out;
  }

  function resolveCountryAccessories(country) {
    var acc = deepClone(QUOTATION_COUNTRY_RATE_DEFAULTS.accessories);
    if (!country) return acc;
    var presetId = country.accessories_preset;
    if (presetId && QUOTATION_ACCESSORY_PRESETS[presetId]) {
      acc = mergeAccessoryNested(acc, QUOTATION_ACCESSORY_PRESETS[presetId]);
    }
    if (country.accessories) {
      acc = mergeAccessoryNested(acc, country.accessories);
    }
    return acc;
  }

  function findCountryByCode(code) {
    if (!code || typeof COUNTRY_CURRENCY === 'undefined') return null;
    return COUNTRY_CURRENCY.find(function (item) {
      return item.country_code === code;
    });
  }

  function getEffectiveCountryCode() {
    if (global.selectedCountryCode) {
      return global.selectedCountryCode;
    }
    if (SITE_OVERRIDES.primaryFreightCountryCode) {
      return SITE_OVERRIDES.primaryFreightCountryCode;
    }
    return '';
  }

  /** 美/日站：09/SR 等仍读主站国家行，不随下拉国别变（与原 getSkuFreightSpecial 一致） */
  function countryForSpecialProductRates() {
    var primary = SITE_OVERRIDES.primaryFreightCountryCode;
    if (primary) {
      return findCountryByCode(primary);
    }
    return findCountryByCode(getEffectiveCountryCode());
  }

  function countryForGeneralFreight() {
    return findCountryByCode(getEffectiveCountryCode());
  }

  /**
   * 读取国家费率（兼容旧 flat 字段与 shipping 嵌套）
   * @param {object|null} country
   * @param {string} flatKey 如 shipping_sm、shipping_trackit、shipping_aesub
   */
  function countryRate(country, flatKey) {
    if (!country) return 0;

    var ship = country.shipping || {};
    var host = ship.host_by_weight || {};
    var acc = resolveCountryAccessories(country);

    var nestedMap = {
      shipping_sm: host.shipping_sm,
      shipping_md: host.shipping_md,
      shipping_lg: host.shipping_lg,
      shipping_trackit_sr: ship.trackit_sr,
      shipping_trackit: ship.trackit,
      shipping_mh: ship.metro_hub,
      shipping_mh_09yu: ship.metrohub_09yu,
      shipping_mh_09tr: ship.metrohub_09tr,
      shipping_aesub: acc.aesub,
      shipping_ab6abp: acc.ab6abp,
      shipping_power: acc.power,
      shipping_02: acc.by_weight.w02,
      shipping_05: acc.by_weight.w05,
      shipping_10: acc.by_weight.w10,
      shipping_20: acc.by_weight.w20,
      shipping_100: acc.by_weight.w100,
      shipping_150: acc.by_weight.w150,
    };

    if (nestedMap[flatKey] != null && nestedMap[flatKey] !== '') {
      return Number(nestedMap[flatKey]) || 0;
    }
    if (country[flatKey] != null && country[flatKey] !== '') {
      return Number(country[flatKey]) || 0;
    }
    return 0;
  }

  function isAccessoryCollectionLabel(label) {
    if (!label) return false;
    var keywords = QUOTATION_CONFIG_DEFAULT.accessoryCollectionKeywords;
    for (var i = 0; i < keywords.length; i++) {
      if (label.indexOf(keywords[i]) > -1) return true;
    }
    return false;
  }

  /** collection 字段（Shopify 集合 title 拼接）或 Item 下拉展示文案 */
  function isAccessoryCollectionContext(collectionOrLabel) {
    return isAccessoryCollectionLabel(collectionOrLabel);
  }

  function isBundleTrackitSku(skuName) {
    if (!skuName) return false;
    if (QUOTATION_CONFIG_DEFAULT.trackitSrSkuPattern.test(skuName)) {
      return false;
    }
    return skuName.indexOf('BUNDLE') > -1 && skuName.indexOf('TRACKIT') > -1;
  }

  function computeUnitFreight(skuName, skuWeight, collectionContext) {
    var cfg = QUOTATION_CONFIG_DEFAULT;
    var country = countryForGeneralFreight();
    var specialCountry = countryForSpecialProductRates();
    if (!country && !specialCountry) return 0;

    if (skuName && cfg.specialFreightBySku[skuName] != null) {
      return Number(cfg.specialFreightBySku[skuName]) || 0;
    }

    if (skuName && cfg.trackitSrSkuPattern.test(skuName)) {
      return countryRate(specialCountry || country, 'shipping_trackit_sr');
    }

    if (skuName && cfg.metroHub09Skus[skuName]) {
      if (cfg.metroHub09Skus[skuName] === 'metrohub_09tr') {
        return countryRate(specialCountry || country, 'shipping_mh_09tr');
      }
      return countryRate(specialCountry || country, 'shipping_mh_09yu');
    }

    if (
      skuName &&
      (cfg.trackitSkuNames.indexOf(skuName) > -1 || isBundleTrackitSku(skuName))
    ) {
      return countryRate(country, 'shipping_trackit');
    }

    if (skuName && cfg.metroHubSkuNames.indexOf(skuName) > -1) {
      return countryRate(country, 'shipping_mh');
    }

    if (skuName && cfg.accessSkuNames.indexOf(skuName) > -1) {
      return getSkuFreightAccess(skuName);
    }

    if (isAccessoryCollectionContext(collectionContext)) {
      return getSkuFreightAccessWeight(skuWeight);
    }

    return getSkuFreight(skuWeight);
  }

  function getSkuFreight(skuWeight) {
    if (!hostFreightEnabled) {
      return 0;
    }
    if (skuWeight == 0 || !getEffectiveCountryCode()) {
      return 0;
    }
    var country = findCountryByCode(getEffectiveCountryCode());
    var thresholds = QUOTATION_CONFIG_DEFAULT.hostWeightThresholds;
    if (skuWeight < thresholds.sm) {
      return countryRate(country, 'shipping_sm');
    }
    if (skuWeight < thresholds.md) {
      return countryRate(country, 'shipping_md');
    }
    return countryRate(country, 'shipping_lg');
  }

  function getSkuFreightSpecial(sku) {
    var country = countryForSpecialProductRates();
    if (!country || !sku) return 0;
    if (sku === 'TRACKIT-SR-STANDARD-EDITION' || QUOTATION_CONFIG_DEFAULT.trackitSrSkuPattern.test(sku)) {
      return countryRate(country, 'shipping_trackit_sr');
    }
    if (sku === 'METRO-HUB-09TR') {
      return countryRate(country, 'shipping_mh_09tr');
    }
    if (sku === 'METRO-HUB-09YU') {
      return countryRate(country, 'shipping_mh_09yu');
    }
    return 0;
  }

  function getSkuFreightTrackit() {
    if (!getEffectiveCountryCode()) return 0;
    var country = findCountryByCode(getEffectiveCountryCode());
    return countryRate(country, 'shipping_trackit');
  }

  function getSkuFreightMetroHub(skuWeight) {
    if (!getEffectiveCountryCode()) {
      return 0;
    }
    if (metroHubRequiresWeight && skuWeight == 0) {
      return 0;
    }
    var country = findCountryByCode(getEffectiveCountryCode());
    return countryRate(country, 'shipping_mh');
  }

  function getSkuFreightAccess(skuName) {
    if (!skuName || !getEffectiveCountryCode()) {
      return 0;
    }
    var country = findCountryByCode(getEffectiveCountryCode());
    if (skuName === 'SCANNING-SPRAY') {
      return countryRate(country, 'shipping_aesub');
    }
    if (skuName === 'SCANNING-SPRAY-AB6' || skuName === 'SCANNING-SPRAY-ABP') {
      return countryRate(country, 'shipping_ab6abp');
    }
    if (skuName === 'POWER-BANK') {
      return countryRate(country, 'shipping_power');
    }
    if (skuName === 'SCANNING-SPRAY-AB6-ABP') {
      return countryRate(country, 'shipping_ab6abp');
    }
    return 0;
  }

  function getSkuFreightAccessWeight(skuWeight) {
    if (skuWeight == 0 || !getEffectiveCountryCode()) {
      return 0;
    }
    var country = findCountryByCode(getEffectiveCountryCode());
    var acc = resolveCountryAccessories(country);
    var thresholds = QUOTATION_CONFIG_DEFAULT.accessoryWeightThresholds;
    for (var i = 0; i < thresholds.length; i++) {
      if (skuWeight < thresholds[i].max) {
        return acc.by_weight[thresholds[i].key] || 0;
      }
    }
    return acc.by_weight.w150 || 0;
  }

  global.QuotationFreight = {
    QUOTATION_CONFIG_DEFAULT: QUOTATION_CONFIG_DEFAULT,
    QUOTATION_COUNTRY_RATE_DEFAULTS: QUOTATION_COUNTRY_RATE_DEFAULTS,
    QUOTATION_ACCESSORY_PRESETS: QUOTATION_ACCESSORY_PRESETS,
    countryRate: countryRate,
    resolveCountryAccessories: resolveCountryAccessories,
    computeUnitFreight: computeUnitFreight,
  };

  global.getSkuFreight = getSkuFreight;
  global.getSkuFreightSpecial = getSkuFreightSpecial;
  global.getSkuFreightTrackit = getSkuFreightTrackit;
  global.getSkuFreightMetroHub = getSkuFreightMetroHub;
  global.getSkuFreightAccess = getSkuFreightAccess;
  global.getSkuFreightAccessWeight = getSkuFreightAccessWeight;
  global.computeUnitFreight = computeUnitFreight;
  global.TRACKIT_SKU_NAMES = TRACKIT_SKU_NAMES;
  global.METROHUB_SKU_NAMES = METROHUB_SKU_NAMES;
  global.ACCESS_SKU_NAMES = ACCESS_SKU_NAMES;
})(typeof window !== 'undefined' ? window : globalThis);
// QUOTATION-FREIGHT-INLINE-END

const countrySelectionDom = $('#countrySelection')
let countryOptionDom = COUNTRY_CURRENCY.reduce((prev, next) => {
  return `${prev} 
  <option value="${next.country_code}" data-currency-code="${next.currency_code}" data-country-code="${next.country_code}">${next.country_name_en}</option>
  `
}, '')
countryOptionDom = '<option value="" selected>Please select</option>' + countryOptionDom

// console.log(`%c>> $`, 'color:yellow', countryOptionDom)

countrySelectionDom.html(countryOptionDom)

// Select2 搜索：忽略大小写，并将空格/连字符/下划线视为等价（如 "aAA BBb" 可匹配 "AAA-BBB"）
function normalizeSelect2SearchText(str) {
  return (str || '').toLowerCase().replace(/[\s\-_]+/g, '')
}

function select2FuzzyMatcher(params, data) {
  if ($.trim(params.term) === '') {
    return data
  }
  if (typeof data.text === 'undefined') {
    return null
  }
  const term = normalizeSelect2SearchText(params.term)
  const text = normalizeSelect2SearchText(data.text)
  if (text.indexOf(term) > -1) {
    return data
  }
  // SKU 下拉：展示文案可能无短名（如 Standard Edition），额外匹配 data-sku-name
  // const skuName = normalizeSelect2SearchText(
  //   (data.element && (data.element.getAttribute('data-sku-name') || data.element.dataset.skuName)) || ''
  // )
  // if (skuName && skuName.indexOf(term) > -1) {
  //   return data
  // }
  return null
}

const QUOTATION_SELECT2_OPTIONS = { matcher: select2FuzzyMatcher }
